import debounce from 'lodash/debounce';

const _debouce = debounce((callback) => callback(), 500, { leading: true, trailing: true });
export default _debouce;
